import apiClient from './client';

export async function createPaymentIntent(amount, currency = 'usd') {
  const res = await apiClient.post('/api/v1/stripe/payment-intent', { amount, currency });
  return res.data;
}

export async function createSetupIntent() {
  const res = await apiClient.post('/api/v1/stripe/setup-intent');
  return res.data;
}

export async function getPaymentMethod() {
  const res = await apiClient.get('/api/v1/stripe/payment-method');
  return res.data;
}

export async function getPayments() {
  const res = await apiClient.get('/api/v1/stripe/payments');
  return res.data;
}

export async function getUnlockStatus() {
  const res = await apiClient.get('/api/v1/stripe/unlock-status');
  return res.data;
}